/******************************************************************************
 * FILE:
 * src/modules/expenseManagement/workflow/components/WorkflowToolbar.jsx
 *
 * MODULE:
 * Expense Management
 *
 * FEATURE:
 * Workflow Master
 *
 * PURPOSE:
 * Search & Action Toolbar
 *
 * RESPONSIBILITY:
 * • Search
 * • Filters
 * • Refresh
 * • Create Workflow
 *
 ******************************************************************************/

import React from "react";

export default function WorkflowToolbar({

  filters,

  onFilterChange,

  onSearch,

  onReset,

  onRefresh,

  onCreate,

}) {

  return (

    <div
      className="card shadow-sm mb-3"
      style={{
        borderRadius: "10px",
      }}
    >

      <div className="card-body">

        <div className="row">

          {/* ------------------------------------------------ */}
          {/* SEARCH */}
          {/* ------------------------------------------------ */}

          <div className="col-md-4 mb-2">

            <label className="form-label">

              Search

            </label>

            <input

              type="text"

              className="form-control"

              placeholder="Code / Name"

              value={filters.search || ""}

              onChange={(e) =>

                onFilterChange(
                  "search",
                  e.target.value
                )

              }

            />

          </div>

          {/* ------------------------------------------------ */}
          {/* WORKFLOW TYPE */}
          {/* ------------------------------------------------ */}

          <div className="col-md-3 mb-2">

            <label className="form-label">

              Workflow Type

            </label>

            <select

              className="form-control"

              value={
                filters.workflow_type || ""
              }

              onChange={(e) =>

                onFilterChange(
                  "workflow_type",
                  e.target.value
                )

              }

            >

              <option value="">

                All

              </option>

              <option value="EXPENSE">

                Expense

              </option>

              <option value="TRAVEL">

                Travel

              </option>

              <option value="ADVANCE">

                Advance

              </option>

            </select>

          </div>

          {/* ------------------------------------------------ */}
          {/* STATUS */}
          {/* ------------------------------------------------ */}

          <div className="col-md-2 mb-2">

            <label className="form-label">

              Status

            </label>

            <select

              className="form-control"

              value={
                filters.is_active ?? ""
              }

              onChange={(e) =>

                onFilterChange(
                  "is_active",
                  e.target.value
                )

              }

            >

              <option value="">

                All

              </option>

              <option value="true">

                Active

              </option>

              <option value="false">

                Inactive

              </option>

            </select>

          </div>

          {/* ------------------------------------------------ */}
          {/* ACTION BUTTONS */}
          {/* ------------------------------------------------ */}

          <div
            className="
              col-md-3
              d-flex
              align-items-end
              justify-content-end
            "
          >

            <button
              className="
                btn
                btn-outline-secondary
                me-2
              "
              onClick={onReset}
            >
              Reset
            </button>

            <button
              className="
                btn
                btn-primary
                me-2
              "
              onClick={onSearch}
            >
              Search
            </button>

            <button
              className="
                btn
                btn-outline-primary
                me-2
              "
              onClick={onRefresh}
            >
              Refresh
            </button>

            <button
              className="
                btn
                btn-success
              "
              onClick={onCreate}
            >
              + Workflow
            </button>

          </div>

        </div>

      </div>

    </div>

  );

}